// extracted by mini-css-extract-plugin
module.exports = {"modal":"Iframe3DSecurity_modal__tjC1T","iframe":"Iframe3DSecurity_iframe__3mP4C","iframeHeader":"Iframe3DSecurity_iframeHeader__1g5en"};